import { IRouter } from 'components/Router'
import { HOMEPAGE_ROUTE } from 'constants/router'

const routes: IRouter[] = [
  {
    path: HOMEPAGE_ROUTE,
    loader: () => import('pages/Home'),
    exact: true,
    type: 'public',
    layout: 'main'
  },
]

export default routes
